<script lang="ts" setup>
import { computed } from "vue";
import { Channel } from "~/entities/channel";
import { IconWhatsAppBusinessApiXL } from "@profeat/ui-kit";
import ModalBodySelect from "./ui/modals/modalBodies/ModalBodySelect.vue";
import BaseModal from "./ui/modals/BaseModal.vue";

const props = defineProps<{
  open: boolean;
  options: Channel[];
}>();

const emit = defineEmits<{
  "update:open": [boolean];
  "item-selected": [Channel];
}>();

const isOpened = computed({
  get() {
    return props.open;
  },
  set(isOpened: boolean) {
    emit("update:open", isOpened);
  },
});
</script>

<template>
  <div>
    <BaseModal
      v-model:open="isOpened"
      title="Выберите канал для рассылки"
      width="small"
    >
      <template #content>
        <ModalBodySelect
          :options="props.options as unknown as Record<string, unknown>[]"
          @item-selected="(item: Record<string, unknown>) => emit('item-selected', item as unknown as Channel)"
        >
          <template #item-template="{ data }">
            <div class="select-item item-body">
              <div class="select-item-icon p-[0_1rem]">
                <IconWhatsAppBusinessApiXL />
              </div>
              <div class="select-item-text mt-[-3px]">
                <span>{{ data.phone }}</span>
              </div>
              <div class="select-item-tag">
                <PTag :disabled="true" :color="'green'" text="Активен" />
              </div>
            </div>
          </template>
        </ModalBodySelect>
      </template>
    </BaseModal>
  </div>
</template>

<style lang="scss" scoped>
.item-body {
  position: relative;
  display: flex;
  align-items: center;
  padding: 1rem 0;
}
.select-item-tag {
  position: absolute;
  right: 1rem;
}
</style>
